export interface MessageContent {
  messageType: string;
  header: string;
  text: string;
  linkName?: string;
  linkText?: string;
}

export const LoginWrongCredentials: MessageContent = {
  messageType: "error",
  header: "Login failed",
  text: "That email and password does not match any accounts in our database.",
  linkName: "mailto:cs@fyr.ai",
  linkText: "Contact support",
};
export const SentResetPasswordEmail: MessageContent = {
  messageType: "info",
  header: "Please check your email.",
  text: "If the address you provided exists in our system, instructions to reset your password was sent there.",
  // linkName: "/help#resetting-password",
  // linkText: "I didn't receive the email."
};
export const SuccessfulPasswordChange: MessageContent = {
  messageType: "success",
  header: "Success!",
  text: "Your password was changed successfully!",
  // linkName: "/auth/login",
  // linkText: "Log in"
};
export const SuccessfulPasswordReset: MessageContent = {
  messageType: "success",
  header: "Your password has been reset!",
  text: "Try logging in with your new password.",
  linkName: "login",
  linkText: "Log in",
};

// TODO: Investigate if the following two messages are used and/or needed.
export const PasswordsDoNotMatch: MessageContent = {
  messageType: "error",
  header: "Passwords do not match!",
  text: "The passwords you provide need to be equal.",
  // linkName: "/help#password-strength",
  // linkText: "Having trouble resetting your password?"
};
export const PasswordValidationError: MessageContent = {
  messageType: "error",
  header: "You need a stronger password.",
  text: "The password needs to contain numbers, letters and special characters.",
  // linkName: "/help#password-strength",
  // linkText: "Need help selecting a strong password?"
};
export function UserCreated(name?: string, email?: string): MessageContent {
  return {
    messageType: "success",
    header: `Welcome, ${name}!`,
    text: `You may now sign in to Fyr using the email ${email} as your username!`,
    linkName: "login",
    linkText: "Sign in",
  };
}
export function InviteError(text: string): MessageContent {
  return {
    messageType: "error",
    header: "Could not invite user",
    text: text,
    // linkName: "/help#invite-users",
    // linkText: "Having trouble inviting users?"
  };
}

export const GenericSomethingWentWrong: MessageContent = {
  messageType: "error",
  header: "Woops!",
  text: "An unexpected error occurred! Please try again later or contact the Fyr support team for help.",
  linkName: "mailto:cs@fyr.ai",
  linkText: "Contact support",
};
